module.exports = __webpack_public_path__ + "static/passport-e11d6a8df159fda455d2d5773a82caa5.jpg";